<div class="container">
  <div class="container-inventory">
    <form #myForm="ngForm">
      <div class="form-card">
        <div class="header">
        <h5 class="title">{{ 'NEW_SUBSCRIPTION' | translate }}</h5>
        <app-back-arrow-settings [callback]="setListingSubscriptions"></app-back-arrow-settings>
        </div>
        <div class="form-couple">
          <div class="form-group col-md-3">
            <label class="form-label is-required" for="product_name">{{"NAME" | translate}}</label>
            <input type="text" class="form-control" id="subscriptionName" placeholder="" (keyup)="changeSubscriptionName($event)" value="{{subscription.name}}" #subscriptionName/>
          </div>
        </div>
        <div class="form-buttons">
          <button type="button" class="btn btn-outline-secondary submit-btn" (click)="validateFormData()">{{"CREATE" | translate}}</button>
        </div>

      </div>
    </form>
  </div>
</div>

<div class="modal subscription-confirm-modal" id="subscriptionLoadingModal" tabindex="-1">
  <div class="modal-dialog subscription-modal-dialog" role="document">
    <div class="modal-content subscription-modal-content">
      <div class="modal-body subscription-modal-body">
        <div class="loading">
          <div class="spinner-border" role="status"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal subscription-confirm-modal" id="successSubscriptionModal" tabindex="-1">
  <div class="modal-dialog subscription-modal-dialog" role="document">
    <div class="modal-content subscription-modal-content">
      <div class="modal-body subscription-modal-body">
        <h3 class="text-center">{{"SUCCESS" | translate}}</h3>
        <p class="text-center">{{ 'SUBSCRIPTION_CREATED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorSubscriptionModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}!</h3>
        <p class="text-center">{{"ERROR_SAVING_CHANGES" | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="requiredSubscriptionModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{ 'SUBSCRIPTION_NAME_REQUIRED' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>
